import styled from 'styled-components';

export const TotalListItems = styled.div`
  color: #fff;
  width: 90%;
  position: relative;
  display: flex;
  background: linear-gradient(45deg, black, transparent);

  margin: 10px auto;
  height: auto;
  justify-content: space-between;
  border-radius: 5px;
`;

export const ListItemsParagraph = styled.p`
  padding: 10px;
  font-size: 18px;
  margin:auto 5px;
  font-weight: 500;
  position: relative;
  width: 80%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;

 
  }
`;

export const IconContainer = styled.span`
  width: 20%;
  cursor: pointer;
  padding: 10px;
  text-align: right;
`;
